import React from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import { formatDecimal, formatLocal } from "../../../../utils/formatNumber";
import {
  AddressLink,
  TruncateAddress,
  TruncateTxn,
} from "../../../shared/utils";
import { TICKERS } from "../../../../constants/tokens";
import { List } from "antd";
import { InteractionOutlined } from "@ant-design/icons";
import "./TokenTransfersItem.scss";

export default function TokenTransfersItem({ item }) {
  return (
    <List.Item key={item.id} className="TokenTransfersItem">
      <List.Item.Meta
        title={
          <Link
            to={`/transaction/${item.txid}`}
            className="TokenTransfersItem__link"
          >
            <InteractionOutlined />
            <TruncateTxn children={item.txid} address={true} />
          </Link>
        }
        description={
          <div className="TokenTransfersItem__description">
            <div className="TokenTransfersItem__description__label">from</div>
            <AddressLink address={item.from}>
              <TruncateAddress children={item.from} address={true} />
            </AddressLink>
            <div className="TokenTransfersItem__description__label--middle">
              to
            </div>
            <AddressLink address={item.to}>
              <TruncateAddress children={item.to} address={true} />
            </AddressLink>
          </div>
        }
      />
      <div className="TokenTransfersItem__content">
        <div>
          {formatLocal(formatDecimal(item.amount))}
          &nbsp;
          <Link to={`/tokens/${item.token}`}>{TICKERS[item.token]}</Link>
        </div>
        <div>
          <Moment fromNow interval={100}>
            {item.date}
          </Moment>
        </div>
      </div>
    </List.Item>
  );
}
